import axios from "axios";
import {API_URL, API_URL_USER} from "../constants/common";

export const loginUser = async (data) => {
    return axios.post(`${API_URL_USER}/users/auth/dashboard/login`, data);
};

export const loginUserGenerate = async (data) => {
    return axios.post(`${API_URL_USER}/users/auth/dashboard/login/generate`, data);
};

export const loginUserVerify = async (data) => {
    return axios.post(`${API_URL_USER}/users/auth/dashboard/login-verify`, data);
};

export const logoutUser = async () => {
    return axios.post(`${API_URL_USER}/users/auth/logout-dashboard`);
};

export const addNewAdmin = async (data) => {
    return axios.post(`${API_URL_USER}/users/addDashboard/admin`, data);
};

export const generateOTP = async (data) => {
    return axios.post(`${API_URL_USER}/users/forget/dashboard/generate-otp`, data);
};

export const verifyOTP = async (data) => {
    return axios.post(`${API_URL_USER}/users/forget/dashboard/verify-otp`, data);
};

export const resetPassword = async ({ userName, password, otp }) => {
    return axios.post(
        `${API_URL_USER}/users/forget/dashboard/password`,
        {
            userName,
            password
        },
        {
            headers: {
                "OTP": otp
            }
        }
    );
};

export const changeAdminPassword = async (data) => {
    return axios.post(`${API_URL_USER}/users/super-admin/change-admin-password`, data);
};


export const getStatistics = async (dateFilter) => {
    // return axios.get(`${API_URL}/dashboard/dashboard-statistics?Date=${dateFilter}`);
    if (dateFilter) {
        return axios.get(`${API_URL}/dashboard/statistics?date=${dateFilter}`);
    }
    return axios.get(`${API_URL}/dashboard/statistics`);
};

export const getTotalRegisteredTaxPayersByDate = async (data) => {
    return axios.get(`${API_URL}/dashboard/total-taxpayer-by-date?issueDateFrom=${data}`);
};

export const getTaxPayersList = async (filter) => {
    let url = `${API_URL}/dashboard/tax-payers?`;
    Object.keys(filter).forEach((k) => {
        url += `${k}=${filter[k]}&`;
    });

    return axios.get(url);
};

export const getLogs = async (filter) => {
    let url = `${API_URL}/dashboard/getAllLogs?`;
    Object.keys(filter).forEach((k) => {
        if (filter[k]) {
            url += `${k}=${filter[k]}&`;
        }
    });
    return axios.get(url);
};

export const getAllAdmins = async (searchData) => {
    let url = `${API_URL}/dashboard/getAllAdmins?`;
    Object.keys(searchData).forEach((k) => {
        if (searchData[k]) {
            url += `${k}=${searchData[k]}&`;
        }
    });
    return axios.get(url);
};

export const getAdminsLogsReport = (filter) => {
    let url = `${API_URL}/dashboard/logs/export-excel?`;
    Object.keys(filter).forEach((k) => {
        url += `${k}=${filter[k]}&`;
    });
    return axios.get(url, {
        responseType: "blob", headers: {"Content-Type": "application/octet-stream"},
    });
};

export const getTaxpayersReport = (date) => {
    return axios.get(`${API_URL}/dashboard/tax-payers/export-excel?startDate=${date}`, {
        responseType: "blob", headers: {"Content-Type": "application/octet-stream"},
    });
};

export const getTaxpayerInvoicesReport = (taxpayerNumber, search) => {
    let url = `${API_URL}/dashboard/tax-payer/${taxpayerNumber}/export-excel?`;
    Object.keys(search).forEach((k) => {
        url += `${k}=${search[k]}&`;
    });
    return axios.get(url, {
        responseType: "blob", headers: {"Content-Type": "application/octet-stream"},
    });
};

export const getTaxPayerInvoicesList = (taxpayerNumber, filter) => {
    let url = `${API_URL}/dashboard/tax-payer/${taxpayerNumber}?`;
    Object.keys(filter).forEach((k) => {
        url += `${k}=${filter[k]}&`;
    });
    return axios.get(url);
};

export const changePassword = async (data) => {
    return axios.post(`${API_URL_USER}/users/resetDash`, data);
};

export const getDevicesList = async (filter) => {
    let url = `${API_URL}/dashboard/tax-payers-devices?`;
    Object.keys(filter).forEach((k) => {
        url += `${k}=${filter[k]}&`;
    });

    const devicesList = await axios.get(url);

    const taxPayerListDto = [];
    devicesList?.taxPayerListDto?.forEach((ele) => {
        ele.taxPayerDevices?.forEach((device) => {
            if (device.activityNumber) {
                taxPayerListDto.push({
                    ...device, name: ele.name, taxNumber: ele.taxNumber,
                });
            }
        });
    });

    return {
        ...devicesList, taxPayerListDto,
    };
};

export const enableDisableDevice = async (activityNumber, dataObject) => {
    return axios.put(`${API_URL}/dashboard/${activityNumber}/status`, dataObject);
};

export const enableDisableCustomerPrice = async (activityNumber, payload) => {
    return axios.put(`${API_URL}/dashboard/customer-price/${activityNumber}/status`, payload);
}

export const enableDisableSummaryInvoice = async (activityNumber, payload) => {
    return axios.post(`${API_URL}/dashboard/summery-invoice/${activityNumber}/status`, payload);
}

export const adminPermission = async (id, dataObject) => {
    return axios.put(`${API_URL}/dashboard/${id}/admin/status`, dataObject);
};

export const deleteAdmin = async (id) => {
    return axios.put(`${API_URL}/dashboard/${id}/admin/disable`);
};

export const editAdminPhone = async (data) => {
    return axios.post(`${API_URL}/users/super-admin/change-admin-phone`,data);
};

// ================ LOOKUP MANAGEMENT API FUNCTIONS ================

// Currency API functions
export const getAllCurrencies = async (currencyCode = '') => {
    const params = currencyCode ? {currency: currencyCode} : {};
    return axios.get(`${API_URL}/dashboard/lu/currency`, {params});
};

export const updateCurrency = async (currencyCode, data) => {
    return axios.put(`${API_URL}/dashboard/lu/currency/update/${currencyCode}`, data);
};

export const toggleCurrencyStatus = async (currencyCode, enabled) => {
    return axios.put(`${API_URL}/dashboard/lu/currency/enabled/${currencyCode}`, enabled);
};

export const addNewCurrency = async (currencyData) => {
    return axios.post(`${API_URL}/dashboard/lu/currency/add-new`, currencyData);
};

// Invoice Type API functions
export const getAllInvoiceTypes = async (code = '') => {
    const params = code ? {code} : {};
    return axios.get(`${API_URL}/dashboard/lu/invoice-type`, {params});
};

export const updateInvoiceType = async (code, data) => {
    return axios.put(`${API_URL}/dashboard/lu/invoice-type/update/${code}`, data);
};

export const toggleInvoiceTypeStatus = async (code, enabled) => {
    return axios.put(`${API_URL}/dashboard/lu/invoice-type/enabled/${code}`, enabled);
};

export const addNewInvoiceType = async (data) => {
    return axios.post(`${API_URL}/dashboard/lu/invoice-type/add-new`, data);
};

// Additional Buyer ID Type API functions
export const getAllAdditionalBuyerIdTypes = async (code = '') => {
    const params = code ? {additionalBuyerIdTypeCode: code} : {};
    return axios.get(`${API_URL}/dashboard/lu/additionalBuyerIdType`, {params});
};

export const updateAdditionalBuyerIdType = async (code, data) => {
    return axios.put(`${API_URL}/dashboard/lu/additionalBuyerIdType/update/${code}`, data);
};

export const toggleAdditionalBuyerIdTypeStatus = async (code, enabled) => {
    return axios.put(`${API_URL}/dashboard/lu/additionalBuyerIdType/enabled/${code}`, enabled);
};

export const addNewAdditionalBuyerIdType = async (data) => {
    return axios.post(`${API_URL}/dashboard/lu/additionalBuyerIdType/add-new`, data);
};

// Province API functions
export const getAllProvinces = async (code = '') => {
    const params = code ? {province: code} : {};
    return axios.get(`${API_URL}/dashboard/lu/province`, {params});
};

export const updateProvince = async (code, data) => {
    return axios.put(`${API_URL}/dashboard/lu/province/update/${code}`, data);
};

// Currency API functions
export const getAllIsic4 = async (currencyCode = '') => {
    const params = currencyCode ? {currency: currencyCode} : {};
    return axios.get(`${API_URL}/dashboard/lu/isic4`, {params});
};

export const updateIsic4 = async (currencyCode, data) => {
    return axios.put(`${API_URL}/dashboard/lu/isic4/update/${currencyCode}`, data);
};

export const toggleIsic4Status = async (currencyCode, enabled) => {
    return axios.put(`${API_URL}/dashboard/lu/isic4/enabled/${currencyCode}`, enabled);
};

export const addNewIsic4 = async (currencyData) => {
    return axios.post(`${API_URL}/dashboard/lu/isic4/add-new`, currencyData);
};
// ================ AUDIT LOG API FUNCTIONS ================
// ================ AUDIT LOG API FUNCTIONS ================
// api/methods.js

// Get audit logs with filter parameters
export const getAuditLogs = async (params = {}) => {
    // Convert the params object to URL parameters
    const queryParams = new URLSearchParams();

    // Add each non-empty parameter to the query string
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value);
        }
    });

    // Convert URLSearchParams to string and log it for debugging
    const queryString = queryParams.toString();
    console.log('API Request URL:', `/audit-logs?${queryString}`);

    // Make the request with axios
    return axios.get(`/dashboard/audit-logs${queryString ? `?${queryString}` : ''}`);
};

//Get audit log actions
export const getAuditLogActions = () => {
    return axios.get('/dashboard/audit-log/actions');
};

// Get action types enum
export const getAuditLogActionTypes = () => {
    return axios.get('/dashboard/audit-logs/action-types');
};

// Get roles enum
export const getAuditLogRoles = () => {
    return axios.get('/dashboard/audit-logs/roles');
};

// Get user types enum
export const getAuditLogUserTypes = () => {
    return axios.get('/dashboard/audit-logs/user-types');
};

// Export audit logs
export const exportAuditLogs = async (params = {}) => {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            console.log(key, value);
            queryParams.append(key, value);
        }
    });

    const queryString = queryParams.toString();
    const decodedQueryString = decodeURIComponent(queryString).replaceAll('+', ' ');
    console.log('API Request URL:', `/dashboard/audit-log/export-excel${decodedQueryString ? `?${decodedQueryString}` : ''}`);
    // Use responseType: 'blob' for file downloads
    return axios.get(`/dashboard/audit-log/export-excel${decodedQueryString ? `?${decodedQueryString}` : ''}`, {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }
    });
};
// Add these methods to your existing api/methods.js file

// ================ SERVICE PROVIDER API FUNCTIONS ================

// Get taxpayer activities by tax number
export const getTaxpayerActivities = async (taxNumber) => {
    return axios.get(`${API_URL_USER}/users/taxpayer/${taxNumber}/activities`);
};

export const deleteServiceProvider = async (serviceProvider) => {
    let url = `${API_URL_USER}/users/service-provider/update-status`;
    return axios.post(url, serviceProvider);

}

// Get all service providers with optional tax number filter
export const getAllServiceProviders = async (filter = {}) => {
    let url = `${API_URL_USER}/users/service-provider?`;
    Object.keys(filter).forEach((k) => {
        if (filter[k]) {
            url += `${k}=${filter[k]}&`;
        }
    });
    return axios.get(url);
};

// Add new service provider
export const addServiceProvider = async (data) => {
    return axios.post(`${API_URL_USER}/users/service-provider`, data);
};

// Get All Certificates with filter
export const getAllCertificates = async (filter = {}) => {
    let url = `${API_URL_USER}/ra/api/certificates/daily-report?`;
    Object.keys(filter).forEach((k) => {
        const v = filter[k];
        if (v !== undefined && v !== null && v !== '') {
            url += `${k}=${encodeURIComponent(v)}&`;
        }
    });
    return axios.get(url);
};

export const exportCertificatesExcel = async (filter = {}) => {
    let url = `${API_URL_USER}/ra/api/certificates/export-daily-report-excel?`;
    Object.keys(filter).forEach((k) => {
        if (filter[k]) {
            url += `${k}=${filter[k]}&`;
        }
    });
    return axios.get(url, {
        responseType: 'blob', headers: {
            'Content-Type': 'application/octet-stream',
        }
    });
};

export const revokeCertificate = async (id, data) => {
    return axios.post(`${API_URL_USER}/ra/api/certificates/force/revoke/${id}`, data);
};

export const getSystemSettings = async (category) => {
    let url = `${API_URL}/dashboard/system-settings`;
    if (category) {
        url += `?category=${category}`;
    }
    return axios.get(url);
};

export const updateSystemSettings = async (data) => {
    return axios.put(`${API_URL}/dashboard/system-settings`, data);
};


// export const getAuditLogs = async (filters) => {
//   let url = `${API_URL}/dashboard/audit-logs?`;
//   Object.entries(filters).forEach(([key, value]) => {
//     if (value) url += `${key}=${encodeURIComponent(value)}&`;
//   });
//   return axios.get(url);
// };

// export const getAuditLogActionTypes = async () => {
//   return axios.get(`${API_URL}/dashboard/audit-logs/action-types`);
// };

// export const getAuditLogRoles = async () => {
//   return axios.get(`${API_URL}/dashboard/audit-logs/roles`);
// };

// export const getAuditLogUserTypes = async () => {
//   return axios.get(`${API_URL}/dashboard/audit-logs/user-types`);
// };

// export const exportAuditLogs = async (filters) => {
//   let url = `${API_URL}/dashboard/audit-logs/export?`;
//   Object.entries(filters).forEach(([key, value]) => {
//     if (value) url += `${key}=${encodeURIComponent(value)}&`;
//   });
//   return axios.get(url, {
//     responseType: "blob",
//     headers: { "Content-Type": "application/octet-stream" },
//   });
// };


